import React, { Component } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { AnalisisForm } from "../components/AnalisisForm";
import "../styles/DetalleSolicitud.css";

class DetalleDRC extends Component {
    state = {
        analisisId: null,
        tipoSolicitud: null,
    };

    componentWillMount() {
        this.setState({ analisisId: this.props.match.params.id });
    }

    regresar = () => {
        this.props.history.goBack();
    };

    setTipoSolicitud = (tipo) => {
        this.setState({ tipoSolicitud: tipo });
    };

    render() {
        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <CardForm
                    icon="laboratorio_activo"
                    titulo="Análisis DRC Producción"
                    subtitulo={
                        this.state.tipoSolicitud || "Sobrante de almacén"
                    }
                    col="12"
                >
                    <AnalisisForm
                        analisisId={this.state.analisisId}
                        modo="detalle"
                        regresar={this.regresar}
                        setTipoSolicitud={this.setTipoSolicitud}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(DetalleDRC);
